import useSWR from 'swr';
import { Client, ClientUser } from '@shared/types';
import { fetcher } from '@/utils/queries';

// generate a custom hook for querying /api/investors/getStartups by investorid
const useInvestor = () => {
  const useStartups = () =>
    useSWR<Client[], Error>(`/api/investors/getStartups`, fetcher);

  const useGetInvestorUsers = (investorId: number) =>
    useSWR<ClientUser[], Error>(
      `/api/users/investor/${investorId}/users`,
      fetcher
    );

  return {
    useStartups,
    useGetInvestorUsers,
  };
};
export default useInvestor;
